// @flow
import { createReducer, createActions } from 'reduxsauce'
import Immutable from 'seamless-immutable'

/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
  getAllEsimsRequest: ['data'],
  getAllEsimsSuccess: ['data'],
  getAllEsimsFailure: ['err'],

  esimUpdateRequest: ['data'],
  esimUpdateSuccess: ['data'],
  esimUpdateFailure: ['err'],

  esimUpdateCountryRequest: ['data'],
  esimUpdateCountrySuccess: ['data'],
  esimUpdateCountryFailure: ['err'],

  esimUpdateVariantRequest: ['data'],
  esimUpdateVariantSuccess: ['data'],
  esimUpdateVariantFailure: ['err'],
})

export const EsimsTypes = Types
export default Creators

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
  fetching: false,
  data: [],
  err: null,
  processing: false,
  success: null
})

/* ------------- Reducers ------------- */
// we're attempting to login
export const request = (state: Object) => state.merge({ fetching: true, err: null, success: null })

// we've successfully logged in
export const success = (state: Object, { data }: Object) =>
  state.merge({
    fetching: false,
    data,
    err: null
  })

// we've had a problem logging in
export const failure = (state: Object, { err }: Object) =>
  state.merge({ fetching: false, err })

// Manipulate data
export const manipulateRequest = (state: Object) => state.merge({ processing: true, success: null, err: null })
export const manipulateSuccess = (state: Object, { data }: Object) =>
  state.merge({
    processing: false,
    success: true,
    err: null
  })
export const manipulateFailure = (state: Object, { err }: Object) => state.merge({ processing: false, err, success: null })

/* ------------- Hookup Reducers To Types ------------- */
export const reducer = createReducer(INITIAL_STATE, {
  [Types.GET_ALL_ESIMS_SUCCESS]: success,
  [Types.GET_ALL_ESIMS_REQUEST]: request,
  [Types.GET_ALL_ESIMS_FAILURE]: failure,

  [Types.ESIM_UPDATE_SUCCESS]: manipulateSuccess,
  [Types.ESIM_UPDATE_REQUEST]: manipulateRequest,
  [Types.ESIM_UPDATE_FAILURE]: manipulateFailure,

  [Types.ESIM_UPDATE_COUNTRY_SUCCESS]: manipulateSuccess,
  [Types.ESIM_UPDATE_COUNTRY_REQUEST]: manipulateRequest,
  [Types.ESIM_UPDATE_COUNTRY_FAILURE]: manipulateFailure,

  [Types.ESIM_UPDATE_VARIANT_SUCCESS]: manipulateSuccess,
  [Types.ESIM_UPDATE_VARIANT_REQUEST]: manipulateRequest,
  [Types.ESIM_UPDATE_VARIANT_FAILURE]: manipulateFailure,
})



// WEBPACK FOOTER //
// ./src/Redux/EsimRedux.js